module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "version-list"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("版本时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('datepicker', {
    ref: "dateFrom",
    staticClass: "form-control",
    model: {
      value: (_vm.queryParam.versionDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "versionDate", $$v)
      },
      expression: "queryParam.versionDate"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("版本名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.versionName),
      expression: "queryParam.versionName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.queryParam.versionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "versionName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("系统平台")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryParam.systemTypes),
      expression: "queryParam.systemTypes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.queryParam, "systemTypes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.systemTypeList), function(option, index) {
    return _c('option', {
      key: 'system' + index,
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t\t")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.searchInfo
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.resetQueryParams
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addVersion
    }
  }, [_vm._v("新建")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list-complete",
      "tag": "tbody"
    }
  }, _vm._l((_vm.fileInfoList), function(fileInfo, index) {
    return _c('tr', {
      key: 'versionHistory' + index
    }, [_c('td', [_vm._v(_vm._s(fileInfo.udcName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.versionDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.versionName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editVersion(index)
        }
      }
    }, [_vm._v("编辑 ")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.removeVersion(index)
        }
      }
    }, [_vm._v(" 删除")])])])
  }), 0)], 1)]), _vm._v(" "), (_vm.fileInfoList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfo
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sub-page', {
    attrs: {
      "show": _vm.showSubPage,
      "bigTitleMsg": _vm.noticeTitle,
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": _vm.closeSubPage
    }
  }, [_c('div', {
    attrs: {
      "slot": "bodycontent"
    },
    slot: "bodycontent"
  }, [_c('page-versionHistory-edit', {
    attrs: {
      "data": _vm.detailInfo,
      "model": _vm.model,
      "udccode": _vm.udccode
    },
    on: {
      "cancel": _vm.closeSubPage,
      "handleSave": _vm.saveSubPage
    }
  })], 1)]), _vm._v(" "), _c('tab-modal', {
    ref: "modalConfirm",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.withdrawSubBtn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmSubBtn
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("系统")]), _vm._v(" "), _c('th', [_vm._v("版本时间")]), _vm._v(" "), _c('th', [_vm._v("版本名称")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21f1ebb6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/versionhistory/PageVersionHistoryList.vue
// module id = 1440
// module chunks = 0